import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IncidentSeverity } from '@models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'avs-incident-severity-icon',
  styleUrls: ['./incident-severity-icon.component.scss'],
  templateUrl: './incident-severity-icon.component.html',
})
export class IncidentSeverityIconComponent {
  severity = input<IncidentSeverity>();
  showLabel = input<boolean>(false);

  protected readonly eIncidentSeverity = IncidentSeverity;
}
